/* eslint-disable camelcase */
import { useCallback, useState } from 'react';

export interface BrasilApiCnpjResponse {
  cnpj: string;
  razao_social: string;
  nome_fantasia: string;
  logradouro: string;
  numero: string;
  bairro: string;
  municipio: string;
  uf: string;
  cep: string;
  email: string;
  ddd_telefone1: string;
  descricao_situacao_cadastral: string;
}

export function useCnpjLookup() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCnpj = useCallback(
    async (cnpj: string): Promise<BrasilApiCnpjResponse | null> => {
      const onlyDigits = cnpj.replace(/\D/g, '');

      if (onlyDigits.length !== 14) {
        setError('CNPJ deve ter 14 dígitos.');
        return null;
      }

      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          `https://brasilapi.com.br/api/cnpj/v1/${onlyDigits}`,
        );

        if (!response.ok) {
          if (response.status === 404) {
            setError('CNPJ não encontrado na Receita Federal.');
          } else {
            setError('Erro ao consultar o CNPJ. Tente novamente.');
          }
          return null;
        }

        const data: BrasilApiCnpjResponse = await response.json();
        return data;
      } catch (err) {
        setError(
          'Não foi possível conectar à BrasilAPI. Verifique sua conexão.',
        );
        return null;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { fetchCnpj, loading, error };
}
